export default __webpack_public_path__ + "974056728475e32bbaf0436dff145ebf.svg";